import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CommonForm from "./CommonForm";
import ListComponent from "./ListComponent";

export default function H5categories(props) {
  return (
    <>
      <div className="flex-row-fluid" {...props}>
        <Switch>
          <Redirect
            from="/html5-categories"
            exact={true}
            to="/html5-categories/list"
          />
          <Route
            path="/html5-categories/list"
            component={ListComponent}
          />
          <Route
            path="/html5-categories/create"
            component={CommonForm}
          />
          <Route
            path="/html5-categories/edit/:id"
            component={CommonForm}
          />
        </Switch>
      </div>
    </>
  );
}
